import React, { Component } from "react";

import { Header, Footer } from "./common";
import {
  Home,
  Publications,
  QrCode,
  Contact,
  NotFound,
  Cgv
} from "./components";

import Translator from "./translations";
import { connect } from "react-redux";
import { setConfig } from "./actions/appConfig";
import _ from "lodash";

import {
  // BrowserRouter as Router,
  HashRouter as Router,
  Route,
  Redirect,
  Switch
} from "react-router-dom";
import "./kiosk.css";
import Api from "./api";
import { cacheKioskPublications } from "./actions/appConfig";

const PrivateRoute = ({
  component: Component,
  condition,
  redirectPath,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      condition ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: redirectPath || "/login",
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

const WrapperRouter = ({
  component: Component,
  condition,
  redirectPath,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      condition ? (
        <div>
          <Header {...props} />
          <main className="site-main">
            <Component {...props} />
          </main>
          <Footer {...props} />
        </div>
      ) : (
        <Redirect
          to={{
            pathname: redirectPath,
            state: { from: props.location }
          }}
        />
      )
    }
  />
);
WrapperRouter.defaultProps = {
  condition: true,
  redirectPath: "/login"
};

class Kiosk extends Component {
  componentWillMount() {
    Translator.locale = this.props.locale;
    document.title = process.env.REACT_APP_KIOSK_NAME;
    const apiKey = this.props.apiKey;
    // console.warn(process.env);
    // console.warn(process.env.REACT_APP_KIOSK_ID);
    // console.warn(process.env.REACT_APP_KIOSK_NAME);
    // console.warn(process.env.REACT_APP_KIOSK_LOGO);
    // console.warn(process.env.REACT_APP_API_URL);
    // console.warn(process.env.REACT_APP_API_SECRETE);
    const authKey = apiKey || process.env.REACT_APP_API_SECRETE;
    Api.loadPublications(authKey, true, false)
      .then(kioskPublications => {
        kioskPublications = _.orderBy(kioskPublications, ["position"], ["asc"]);
        this.props.cacheKioskPublications(kioskPublications);
      })
      .catch(error => {
        this.props.cacheKioskPublications([]);
      });
  }

  render() {
    return (
      <Router>
        <Switch>
          <WrapperRouter exact path="/" component={Home} />
          <PrivateRoute
            path="/publications"
            condition={true}
            component={Publications}
            redirectPath="/login"
          />
          <WrapperRouter path="/contact" component={Contact} />

          <WrapperRouter path="/cgv" component={Cgv} />
          <WrapperRouter exact path="/qr/:qrcode" component={QrCode} />

          <WrapperRouter component={NotFound} />
        </Switch>
      </Router>
    );
  }
}

function bindAction(dispatch) {
  return {
    setConfig: config => dispatch(setConfig(config)),
    cacheKioskPublications: kioskPublications =>
      dispatch(cacheKioskPublications(kioskPublications))
  };
}

const mapStateToProps = state => ({
  apiKey: state.security.user ? state.security.user.apiKey : null,
  user: state.security.user || null,
  isAuth: !!state.security.user,
  locale: state.appConfig.locale
});

export default connect(
  mapStateToProps,
  bindAction
)(Kiosk);



// WEBPACK FOOTER //
// ./src/Kiosk.js